import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    Collapse,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/plus.svg";
import { ReactComponent as Plus } from "../../../../assets/icons/plus.svg";
import { ReactComponent as TrashRed } from "../../../../assets/images/trashRed.svg";
import { ReactComponent as TrashRedDis } from "../../../../assets/images/trashRedDis.svg";
import { ReactComponent as Expand } from "../../../../assets/images/expand.svg";
import { ReactComponent as ExpandOpen } from "../../../../assets/images/expand-open.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import customFormTemplate from "../../../../services/customFormTemplate.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const CompetencyTypeCreate = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        getListIcon()
        getListScaleDropdown()
        getDetail()
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "16px !important",
            "margin-bottom": "8px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "16px !important",
            "margin-bottom": "8px !important",
            "& .MuiOutlinedInput-root": {
                padding: "0",
            },
            '& div > textarea': {
                padding: "8px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "16px !important",
            "margin-bottom": "8px !important",
            "& .MuiOutlinedInput-root": {
                padding: "0",
            },
            '& div > textarea': {
                padding: "8px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        inputItemDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputItem: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            "& .MuiOutlinedInput-root": {
                padding: "0",
            },
            '& div > textarea': {
                padding: "8px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputItemError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            "& .MuiOutlinedInput-root": {
                padding: "0",
            },
            '& div > textarea': {
                padding: "8px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        selectDisabled: {
            "margin-top": "16px !important",
            "margin-bottom": "0px !important",
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "8.56px 14px"
            }
        },
        select: {
            "margin-top": "16px !important",
            "margin-bottom": "0px !important",
            '& div ': {
                padding: "8.56px 14px"
            }
        },
        selectError: {
            "margin-top": "16px !important",
            "margin-bottom": "0px !important",
            '& div ': {
                padding: "8.56px 14px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    let { serial, cycleID } = useParams()

    const [List, setList] = React.useState({
        config: [
            {
                color: "#BF9257",
            },
            {
                color: "#C1774E",
            },
            {
                color: "#4B8178",
            },
            {
                color: "#5D9ABE",
            },
            {
                color: "#336AA1",
            },
            {
                color: "#6A5A93",
            },
            {
                color: "#9C5684",
            },
            {
                color: "#984343",
            },
            {
                color: "#EFB76D",
            },
            {
                color: "#F19562",
            },
            {
                color: "#5DA196",
            },
            {
                color: "#74C1ED",
            },
            {
                color: "#4085C9",
            },
            {
                color: "#8470B8",
            },
            {
                color: "#C36BA5",
            },
            {
                color: "#BE5454",
            },
            {
                color: "#F7DBB6",
            },
            {
                color: "#F8CAB1",
            },
            {
                color: "#AED0CA",
            },
            {
                color: "#BAE0F6",
            },
            {
                color: "#9FC2E4",
            },
            {
                color: "#D8D3E9",
            },
            {
                color: "#E1B5D2",
            },
            {
                color: "#DFA9A9",
            },
            {
                color: "#FDF8F0",
            },
            {
                color: "#FEF4EF",
            },
            {
                color: "#EFF6F4",
            },
            {
                color: "#F1F9FD",
            },
            {
                color: "#ECF3FA",
            },
            {
                color: "#F3F1F8",
            },
            {
                color: "#F9F0F6",
            },
            {
                color: "#F9EEEE",
            },
        ]
    });
    const [status, setStatus] = React.useState(true);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [selectIndex, setSelectIndex] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [openDel, setOpenDel] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [dataIcon, setDataIcon] = React.useState([]);
    const [checkCode, setCheckCode] = React.useState(false);
    const [checkError, setCheckError] = React.useState(false);
    const [valueIndex, setValueIndex] = React.useState(0);
    const [probation_topic, setProbationTopic] = React.useState([]);
    const [probationItem, setProbationItem] = React.useState({});
    const [dataDel, setDataDel] = React.useState({});
    const [ratingScale, setratingScale] = React.useState([]);
    const [ratingScaleLv, setratingScaleLv] = React.useState([]);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [openColor, setOpenColor] = React.useState({});
    const [onChangeRatingScale, setOnChangeRatingScale] = React.useState(false);
    const [statusUse, setStatusUse] = React.useState(false);

    const anchorRef = React.useRef(null);
    const handleStatus = () => {
        setStatus(!status)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        nameTH: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        rating_scale: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: "",
            nameEN: "",
            nameTH: "",
            instructint_en: "",
            instructint_th: "",
            rating_scale: "",
            expected_rating: "",
            probation_topic: []
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // adminService.checkCode("competency_type", values.code).then(
            //     (response) => {
            //         setCheckCode(response?.data?.is_exist)
            //         if (response?.data?.is_exist === false) {
            if (checkData(values.probation_topic)) {
                submit(values)
            }
            setCheckError(!checkError)
            //         }
            //     },
            // ).catch(() => {
            // })
        },
    });

    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);

    useEffect(() => {
        if (Util.formatData(formik.values.rating_scale, false)) {
            getListScaleLevelDropdown(formik.values.rating_scale)
            if (onChangeRatingScale) {
                formik.setFieldValue("expected_rating", "")
            }
        }
    }, [formik.values.rating_scale]);

    let getDetail = () => {
        customFormTemplate.getProbationTemplate(serial, cycleID).then((rs) => {
            let data = Util.formatData(rs?.data?.probation_template, {})
            formik.setFieldValue("code", Util.formatData(data?.code, ""))
            formik.setFieldValue("nameEN", Util.formatData(data?.name_en, ""))
            formik.setFieldValue("nameTH", Util.formatData(data?.name_th, ""))
            formik.setFieldValue("instructint_en", Util.formatData(data?.instructint_en, ""))
            formik.setFieldValue("instructint_th", Util.formatData(data?.instructint_th, ""))
            formik.setFieldValue("rating_scale", Util.formatData(data?.rating_scale, ""))
            formik.setFieldValue("expected_rating", Util.formatData(data?.expected_rating, ""))
            setStatus(Util.formatData(data?.status, "") === "active")
            setStatusUse(data?.is_used)
            if (Util.formatData(data?.probation_topic, []).length > 0) {
                let probation_topic = data?.probation_topic
                let showProbationTopic = []
                let item = {}
                for (let index = 0; index <= probation_topic.length - 1; index++) {
                    let time = `${Date.now()}` + index
                    probation_topic[index].time = time
                    showProbationTopic.push({})
                    item[time] = Util.formatData(probation_topic[index]?.probation_item, [{}])
                }
                formik.setFieldValue("probation_topic", data?.probation_topic)
                setProbationTopic(showProbationTopic)
                setProbationItem(item)
            }
            setOnChangeRatingScale(true)
        })
    }
    const onOpenIcon = (data,) => {
        setSelectIndex(data)
        setOpenIcon(true)
    }
    const onCloseIcon = () => {
        setOpenIcon(false)
    }
    const onSelectIcon = (e) => {
        setDataItem(e, "probation_topic", "icon", selectIndex)
        setOpenIcon(false)
    }

    useEffect(() => {
        if (Util.formatData(document.getElementsByClassName('Mui-error'), []).length > 0) {
            setTimeout(() => {
                document.getElementsByClassName('Mui-error')[0].scrollIntoView({ behavior: "smooth", block: "center" })
            }, 300);
        }
    }, [checkError]);

    const handleSubmit = () => {
        if (onSubmit === false) {
            setOnSubmit(true)
        }
        setCheckError(!checkError)
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/custom-form-template')
    };
    const confirmDel = (status) => {
        if (status === "no") {
            setDataDel({})
        } else if (Util.formatData(dataDel?.dataLoop, false) !== false && Util.formatData(dataDel?.index, false) !== false && Util.formatData(dataDel?.time, false) !== false) {
            formikDelete(dataDel.dataLoop, "probation_topic", setProbationTopic, dataDel.index, dataDel.time)
            setValueIndex(dataDel.dataLoop.length - 2)
        }
        setOpenDel(false)
    };

    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/custom-form-template', { replace: false, state: { cycleID: cycleID } });
    }
    const submit = (data) => {
        customFormTemplate.updateProbationTemplate(serial, {
            cycle_id: cycleID,
            code: data.code,
            name_en: data.nameEN,
            name_th: data.nameTH,
            status: status === true ? "active" : "inactive",
            instructint_en: data.instructint_en,
            instructint_th: data.instructint_th,
            rating_scale: data.rating_scale,
            expected_rating: data.expected_rating,
            probation_topic: data.probation_topic
        }).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`admin.label.customFormTemplateCannotUpdate`))
            handleOpenFailedMessageDialog(true)
        })
    }
    const getListScaleDropdown = (data) => {
        customFormTemplate.getListScaleDropdown().then(
            (response) => {
                setratingScale(Util.formatData(response?.data?.kpi_scale, []));
            },
        ).catch(() => {
        })
    }
    const getListScaleLevelDropdown = (data) => {
        customFormTemplate.getListScaleLevelDropdown(data).then(
            (response) => {
                setratingScaleLv(Util.formatData(response?.data?.kpi_scale_level, []));
            },
        ).catch(() => {
        })
    }
    const onOpenColor = (time) => {
        let data = JSON.parse(JSON.stringify(openColor))
        if (Util.formatData(data[time], "not") === "not") {
            data[time] = true
        } else {
            data[time] = !data[time]
        }
        setOpenColor(data);
    }
    const getListIcon = () => {
        adminService.listIcon().then(
            (response) => {
                setDataIcon(response.data.icon)
            },
        )
    }
    const handleClose = (event, time) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        let data = JSON.parse(JSON.stringify(openColor))
        data[time] = false
        setOpenColor(data);
    };
    const handleCollapse = (data) => {
        if (data !== valueIndex) {
            setValueIndex(data)
        } else {
            setValueIndex("")
        }
    }

    const selectDel = (dataLoop, field, setData, index, time, order) => {
        let data = {
            dataLoop: dataLoop,
            field: field,
            setData: setData,
            index: index,
            time: time,
            order: order
        }
        setDataDel(data)
        setOpenDel(true)
    }

    const formikDelete = async (dataLoop, field, setData, index, time, order) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        let probationItems = JSON.parse(JSON.stringify(probationItem))
        if (field === "probation_item") {
            data.probation_topic[index].probation_item.splice(order, 1)
            dataShow[time].splice(order, 1)
        } else {
            data.probation_topic.splice(index, 1)
            dataShow.splice(index, 1)
            delete probationItems[time]
            setProbationItem(probationItems)
        }
        await setData(dataShow)
        formik.setFieldValue("probation_topic", data.probation_topic)
    }
    const addProbationTopic = () => {
        let time = `${Date.now()}${probation_topic.length}`
        formik.setFieldValue("probation_topic", [...formik.values.probation_topic, { name_en: "", name_th: "", ratio: "", icon: "", time: time, color: "#5DA196", probation_item: [{ name_en: "", name_th: "", weight: "" }] }])
        let item = JSON.parse(JSON.stringify(probationItem))
        item[time] = [{}]
        setProbationItem(item)
        let data = [...probation_topic, {}]
        setProbationTopic(data)
        setValueIndex(data.length - 1)
    }
    const addProbationItem = (time, index) => {
        let item = JSON.parse(JSON.stringify(probationItem))
        let topic = JSON.parse(JSON.stringify(formik.values.probation_topic))
        item[time] = [...item[time], {}]
        topic[index].probation_item = [...topic[index].probation_item, { name_en: "", name_th: "", weight: "" }]
        setProbationItem(item)
        formik.setFieldValue("probation_topic", topic)
    }
    const changeProbation_topic = (val, field, subField, index, key, order) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        if (Util.formatData(key, false) !== false) {
            data[field][index][subField][order] = { ...formik.values[field][index][subField][order], [key]: val.target.value }
            formik.setFieldValue(field, data[field])
        } else {
            data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
            formik.setFieldValue(field, data[field])
        }
    }
    const formikChangeNumber = (val, field, subField, index, key, order) => {
        const regexD = /[^0-9.]/g;
        const found = val.target.value.match(regexD);
        let indexof = val.target.value.indexOf(".")
        let lastIndexof = val.target.value.lastIndexOf(".")
        if (found !== null || val.target.value === "." || indexof !== lastIndexof) {

        } else {
            if (indexof === -1) {
                let data = JSON.parse(JSON.stringify(formik.values))
                if (Util.formatData(key, false) !== false) {
                    data[field][index][subField][order] = { ...formik.values[field][index][subField][order], [key]: val.target.value }
                    formik.setFieldValue(field, data[field])
                } else {
                    data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
                    formik.setFieldValue(field, data[field])
                }
            } else if (indexof > 0 && (val.target.value.length - 1) - lastIndexof <= 1) {
                let data = JSON.parse(JSON.stringify(formik.values))
                if (Util.formatData(key, false) !== false) {
                    data[field][index][subField][order] = { ...formik.values[field][index][subField][order], [key]: val.target.value }
                    formik.setFieldValue(field, data[field])
                } else {
                    data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
                    formik.setFieldValue(field, data[field])
                }
            }
        }
    }

    const setDataItem = (val, field, subField, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], [subField]: val }
        formik.setFieldValue(field, data[field])
    }
    let sumWeight = (data) => {
        let sum = parseFloat(0)
        if (Util.formatData(data, []).length > 0) {
            for (let index = 0; index <= data.length - 1; index++) {
                sum = parseFloat(sum)
                let getNum = Util.formatData(data[index]?.weight, 0)
                //console.log('weight', sum, data[index]?.weight, getNum, Number(getNum))
                sum = (sum + parseFloat(getNum)).toFixed(2)
            }
        }
        sum = parseFloat(sum)
        //console.log('sumWeight', sum)
        return sum
    }
    let sumRatio = (data) => {
        let sum = 0
        if (Util.formatData(data, []).length > 0) {
            for (let index = 0; index <= data.length - 1; index++) {
                sum = parseFloat(sum)
                let getNum = Util.formatData(data[index]?.ratio, 0)
                //sum = sum + Number(getNum)
                sum = (sum + parseFloat(getNum)).toFixed(2)
            }
        }
        sum = parseFloat(sum)
        return sum
    }
    let checkData = (data) => {
        let check = true
        //     name_en: "",
        //     name_th: "",
        //     ratio: "",
        //     icon: "",
        //     color: "#5DA196",
        //     time: time,
        //     probation_item: [
        //         {
        //             name_en: "",
        //             name_th: "",
        //             weight: ""
        //         }
        //     ]
        if (Util.formatData(formik.values.nameTH, "").length <= 30 && Util.formatData(formik.values.nameEN, "").length <= 30) {
            if (Util.formatData(data, []).length > 0) {
                if (sumRatio(data) === 100) {
                    let error = -1
                    for (let index = 0; index <= data.length - 1; index++) {
                        if (check && Util.formatData(data[index]?.name_en, false) === false) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.name_th, false) === false) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.name_en, false) !== false && data[index]?.name_en.length > 100) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.name_th, false) !== false && data[index]?.name_th.length > 100) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.ratio, false) === false) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.icon, false) === false) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.color, false) === false) {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        } else if (check && Util.formatData(data[index]?.probation_item, []).length > 0) {
                            if (check && sumWeight(data[index]?.probation_item) === 100) {
                                for (let idx = 0; idx <= data[index]?.probation_item.length - 1; idx++) {
                                    let probation_item = data[index]?.probation_item[idx]
                                    if (check && Util.formatData(probation_item?.name_en, false) === false) {
                                        check = false
                                        if (error < 0) {
                                            error = index
                                        }
                                    } else if (check && Util.formatData(probation_item?.name_th, false) === false) {
                                        check = false
                                        if (error < 0) {
                                            error = index
                                        }
                                    } else if (check && Util.formatData(probation_item?.weight, false) === false) {
                                        check = false
                                        if (error < 0) {
                                            error = index
                                        }
                                    }
                                }
                            } else {
                                check = false
                                if (error < 0) {
                                    error = index
                                }
                            }
                        } else {
                            check = false
                            if (error < 0) {
                                error = index
                            }
                        }
                    }
                    if (error >= 0) {
                        setValueIndex(error)
                    }
                } else {
                    check = false
                }
            } else {
                check = false
            }
        } else {
            check = false
        }
        return check
    }

    let getName = (data) => {
        let dataMain = data.toLowerCase()
        let index = dataMain.search("<br")
        if (Util.formatData(data, false) !== false) {
            if (index >= 0) {
                return data.substr(0, index)
            } else {
                return data
            }
        }
        return ""
    }
    return (
        <>
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/custom-form-template')}>{t('admin.label.customFormTemplate')}</span> / <span style={styles.end} >{t('admin.label.editCustomFormTemplate')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} color="#404349" lineHeight="53.82px" fontWeight="600">
                                {t('admin.label.editCustomFormTemplate')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{ ".Mui-error .MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058 !important" } }}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                disabled
                                                placeholder="Fill the custom form template code"
                                                classes={{ root: classes.disabled }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>}
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch checked={status} disabled={statusUse !== true ? false : true} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.nameEN, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.nameEN, "").length <= 30 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.nameEN, "").length}/30</Typography>
                                            </Box>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN) || Util.formatData(formik.values.nameEN, "").length > 30}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder="Fill the custom form template name"
                                                classes={{ root: classes.input }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.nameTH, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.nameTH, "").length <= 30 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.nameTH, "").length}/30</Typography>
                                            </Box>
                                            <TextField
                                                error={Boolean(formik.touched.nameTH && formik.errors.nameTH) || Util.formatData(formik.values.nameTH, "").length > 30}
                                                fullWidth
                                                helperText={formik.touched.nameTH && formik.errors.nameTH}
                                                margin="normal"
                                                name="nameTH"
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameTH}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                placeholder="Fill the custom form template name"
                                                classes={{ root: classes.input }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} spacing={4} sx={{ padding: "30px 0px 20px 25px", display: "block" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0px !important" }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.formInstructionEN')} </Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="instructint_en"
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.instructint_en}
                                                multiline
                                                minRows={2}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                placeholder="Describe this custom form template"
                                                classes={{ root: classes.inputTopic }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} spacing={4} sx={{ padding: "30px 0px 20px 25px", display: "block" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.formInstructionTH')} </Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="instructint_th"
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.instructint_th}
                                                multiline
                                                minRows={2}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder="Describe this custom form template"
                                                classes={{ root: classes.inputTopic }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 32px 25px" }}>
                                        <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.ratingScale')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                            </Box>
                                            <Select
                                                variant="outlined"
                                                defaultValue=""
                                                displayEmpty
                                                size="small"
                                                fullWidth
                                                name="rating_scale"
                                                // disabled={item.edit === false ? true : false}selectError
                                                className="white-bg"
                                                error={Boolean(formik.touched.rating_scale && formik.errors.rating_scale)}
                                                onChange={formik.handleChange}
                                                value={formik.values.rating_scale}
                                                MenuProps={{ autoFocus: false, }}
                                                classes={{ root: classes.select }}
                                            >
                                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select rating scale</Typography>
                                                </MenuItem>
                                                {ratingScale.length > 0 ?
                                                    ratingScale.map(dt => {
                                                        return (
                                                            <MenuItem value={dt.serial} key={dt.serial} >
                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{Util.formatData(dt?.code, false) !== false && Util.formatData(dt?.name, false) !== false ? `${dt?.code} - ${dt?.name}` : `${dt?.code}${dt?.name}`}</span>
                                                            </MenuItem>
                                                        )
                                                    })
                                                    :
                                                    null
                                                }
                                            </Select>
                                            {Boolean(formik.touched.rating_scale && formik.errors.rating_scale) ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.expectRating')}</Typography>
                                            </Box>
                                            <Select
                                                variant="outlined"
                                                defaultValue=""
                                                displayEmpty
                                                size="small"
                                                fullWidth
                                                // disabled={item.edit === false ? true : false}selectError
                                                name="expected_rating"
                                                className="white-bg"
                                                onChange={formik.handleChange}
                                                value={formik.values.expected_rating}
                                                MenuProps={{ autoFocus: false, }}
                                                classes={{ root: classes.select }}
                                            >
                                                <MenuItem value="" >
                                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select expected rating</Typography>
                                                </MenuItem>
                                                {ratingScaleLv.length > 0 ?
                                                    ratingScaleLv.map(dt => {
                                                        return (
                                                            <MenuItem value={dt.serial} key={dt.serial} >
                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{Util.formatData(dt?.value, false) !== false && Util.formatData(dt?.description, false) !== false ? `${dt?.value} - ${getName(dt?.description)}` : `${dt?.value}${getName(dt?.description)}`}</span>
                                                            </MenuItem>
                                                        )
                                                    })
                                                    :
                                                    null
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid container item sx={{ pt: "30px", width: "100%", justifyContent: "space-between" }}>
                                <Typography fontSize={30} color="#404349" lineHeight="44.85px" fontWeight="600">
                                    {t('label.category')}
                                </Typography>
                                <Box display="flex" alignItems="center">
                                    {/* <Typography pr="30px" fontSize={18} color="#404349" lineHeight="26.91px" fontWeight="500">
                                        {t('label.totalRatio')}:
                                    </Typography>
                                    <Typography pr="30px" fontSize={18} color={sumRatio(formik.values.probation_topic) > 0 ? sumRatio(formik.values.probation_topic) === 100 ? "#5DA196" : "#CC6058" : "#BABABA"} lineHeight="26.91px" fontWeight="500">
                                        {sumRatio(formik.values.probation_topic)}
                                    </Typography> */}
                                    <Button color="black" variant="outlined" sx={{ textTransform: "none", pt: "8px", pb: "8px" }} onClick={addProbationTopic}>
                                        <PlusIcon className={classes.fillBlack} />
                                        <Typography pl="5px" fontWeight={500} color="#404349" fontSize={18} lineHeight="26.91px" display="flex">
                                            {/* {t('label.add')} */}
                                            Add
                                        </Typography>
                                    </Button>
                                </Box>
                            </Grid>
                            {Util.formatData(probation_topic, []).length > 0 ? probation_topic.map((rs, index) => (
                                <Grid container item sx={{ pt: "30px" }}>
                                    <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                        <Grid container lg md xs={12} display="flex" sx={{ padding: "15px 32px 15px 25px" }}>
                                            <Grid item lg={12} md={12} xs={12} display="flex" justifyContent="space-between" sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": "#FAFAFA", "-webkit-text-fill-color": "#000 !important" }, "fieldset": { "border-color": "#FFFFFF !important" } }}>
                                                <Typography variant="subtitle1" color="#404349" fontSize={24} lineHeight="35px" fontWeight={600} display="flex">Category {index + 1}</Typography>
                                                <Box id="prevent" sx={{ zIndex: 1 }}>
                                                    <div className={`clickable ${classes.expandableIcon} ${valueIndex === index ? 'active' : ''}`} style={{ display: "flex" }} onClick={e => handleCollapse(index)} id="prevent">
                                                        {valueIndex === index ?
                                                            <Expand sx={{ fontSize: "15px", width: "35px", height: "35px" }} id="prevent" />
                                                            :
                                                            <ExpandOpen sx={{ fontSize: "15px", width: "35px", height: "35px" }} id="prevent" />
                                                        }

                                                    </div>
                                                </Box>
                                            </Grid>
                                            {valueIndex === index ?
                                                <Grid container lg={12} md={12} xs={12} display="flex" sx={{ padding: "15px 0px 0px" }}>
                                                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                                : null
                                            }
                                        </Grid>
                                        <Collapse in={valueIndex === index}>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                        <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">Category Name EN <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.probation_topic[index].name_en, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.probation_topic[index].name_en, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.probation_topic[index].name_en, "").length}/100</Typography>
                                                    </Box>
                                                    <TextField
                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.name_en, false) === false || Util.formatData(formik.values.probation_topic[index].name_en, "").length > 100 : Util.formatData(formik.values.probation_topic[index].name_en, "").length > 100}
                                                        fullWidth
                                                        margin="normal"
                                                        name="nameEN"
                                                        onChange={e => changeProbation_topic(e, "probation_topic", "name_en", index)}
                                                        type="text"
                                                        value={formik.values.probation_topic[index].name_en}
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        placeholder="Fill the category name"
                                                        classes={{ root: classes.input }}
                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                    />
                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.name_en, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                        <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="24px" display="flex">Category Name TH <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.probation_topic[index].name_th, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.probation_topic[index].name_th, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.probation_topic[index].name_th, "").length}/100</Typography>
                                                    </Box>
                                                    <TextField
                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.name_th, false) === false || Util.formatData(formik.values.probation_topic[index].name_th, "").length > 100 : Util.formatData(formik.values.probation_topic[index].name_th, "").length > 100}
                                                        fullWidth
                                                        margin="normal"
                                                        name="nameTH"
                                                        onChange={e => changeProbation_topic(e, "probation_topic", "name_th", index)}
                                                        type="text"
                                                        value={formik.values.probation_topic[index].name_th}
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                        placeholder="Fill the category name"
                                                        classes={{ root: classes.input }}
                                                    />
                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.name_th, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                        <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">Category Ratio <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                        {/* <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.nameEN, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.nameEN, "").length <= 30 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.nameEN, "").length}/60</Typography> */}
                                                    </Box>
                                                    <TextField
                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.ratio, false) === false ? true : sumRatio(formik.values.probation_topic) === 100 ? false : true : false}
                                                        fullWidth
                                                        margin="normal"
                                                        name="nameEN"
                                                        onChange={e => formikChangeNumber(e, "probation_topic", "ratio", index)}
                                                        type="text"
                                                        value={formik.values.probation_topic[index].ratio}
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        placeholder="Fill the category ratio"
                                                        classes={{ root: classes.input }}
                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                    />
                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.ratio, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : sumRatio(formik.values.probation_topic) === 100 ? <></> : (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>The total ratio must be equal to 100. </FormHelperText>) : <></>}
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} spacing={4} sx={{ padding: "30px 0px 20px 25px", display: "block" }}>
                                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">Item</Typography>
                                                    <Box mt="10px" sx={{ border: onSubmit === true ? probation_topic.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                        <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                            <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">Manage Item {onSubmit && sumWeight(formik.values.probation_topic[index].probation_item) !== 100 && sumWeight(formik.values.probation_topic[index].probation_item) > 0 ? <span style={{ "padding-left": "50px", color: "#CC6058", "font-weight": "500", "font-size": "14px", "line-height": "24px", }}>The total weight must be equal to 100.</span> : ""}</Typography>
                                                            <Box onClick={e => addProbationItem(formik.values.probation_topic[index].time, index)} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                                <Plus />
                                                                <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                    {/* {t('label.add')} */}
                                                                    Add
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": probation_topic !== undefined && probation_topic !== null && probation_topic.length > 0 ? "999999px" : "0px" }}>
                                                            {probation_topic !== undefined && probation_topic !== null && probation_topic.length > 0 ?
                                                                <Box>
                                                                    <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                                        <Divider />
                                                                        <Box sx={{ height: "48px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                            <Box sx={{ width: "calc(41.37% - 20px)" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Item Name EN <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "calc(41.37% - 20px)" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Item Name TH <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "calc(17.26% - 20px)" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Weight (%) <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                                            </Box>
                                                                            <Box sx={{ width: "60px" }}>
                                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.action')}</Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                    {Util.formatData(probationItem[formik.values.probation_topic[index]?.time], []).map((item, order) => (
                                                                        <Box sx={{ width: "100%" }} >
                                                                            <Box sx={{ minHeight: "49px", padding: "0 25px", display: "flex", }}>
                                                                                <Box sx={{ width: "calc(41.37% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, ".MuiFormHelperText-root": { marginTop: "3px" } }} py="11px" pr="40px">
                                                                                    <TextField
                                                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.name_en, false) === false : false}
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                        name="nameEN"
                                                                                        onChange={e => changeProbation_topic(e, "probation_topic", "probation_item", index, "name_en", order)}
                                                                                        type="text"
                                                                                        value={formik.values.probation_topic[index].probation_item[order].name_en}
                                                                                        multiline
                                                                                        minRows={2}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        placeholder="Fill the item name"
                                                                                        classes={{ root: classes.inputItem }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                                                    />
                                                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.name_en, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                                                </Box>
                                                                                <Box sx={{ width: "calc(41.37% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, ".MuiFormHelperText-root": { marginTop: "3px" } }} py="11px" pr="40px">
                                                                                    <TextField
                                                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.name_th, false) === false : false}
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                        name="nameEN"
                                                                                        onChange={e => changeProbation_topic(e, "probation_topic", "probation_item", index, "name_th", order)}
                                                                                        type="text"
                                                                                        value={formik.values.probation_topic[index].probation_item[order].name_th}
                                                                                        multiline
                                                                                        minRows={2}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        placeholder="Fill the item name"
                                                                                        classes={{ root: classes.inputItem }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                                                    />
                                                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.name_th, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                                                </Box>
                                                                                <Box sx={{ width: "calc(17.26% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, ".MuiFormControl-root": { pr: "40px" }, ".MuiFormHelperText-root": { marginTop: "3px" } }} py="11px">
                                                                                    <TextField
                                                                                        error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.weight, false) === false ? true : sumWeight(formik.values.probation_topic[index].probation_item) === 100 ? false : true : false}
                                                                                        fullWidth
                                                                                        margin="normal"
                                                                                        name="nameEN"
                                                                                        onChange={e => formikChangeNumber(e, "probation_topic", "probation_item", index, "weight", order)}
                                                                                        type="text"
                                                                                        value={formik.values.probation_topic[index].probation_item[order].weight}
                                                                                        multiline
                                                                                        minRows={2}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        placeholder="Fill the weight"
                                                                                        classes={{ root: classes.inputItem }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                                                    />
                                                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.probation_item[order]?.weight, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                                                </Box>
                                                                                <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="32px">
                                                                                    <Delete style={{ opacity: formik?.values?.probation_topic[index]?.probation_item.length > 1 ? "" : "0.2", cursor: formik?.values?.probation_topic[index]?.probation_item.length > 1 ? "pointer" : "" }} onClick={e => formik?.values?.probation_topic[index]?.probation_item.length > 1 ? formikDelete(probationItem, "probation_item", setProbationItem, index, formik.values.probation_topic[index].time, order) : null} />
                                                                                </Box>
                                                                            </Box>
                                                                            <Divider />
                                                                        </Box>
                                                                    ))
                                                                    }
                                                                    <Box sx={{ width: "100%", display: "flex", p: "15px 25px 0" }}>
                                                                        <Box sx={{ width: "calc(41.37% - 20px)" }}>

                                                                        </Box>
                                                                        <Box sx={{ width: "calc(41.37% - 20px)" }}>

                                                                        </Box>
                                                                        <Box sx={{ width: "calc(17.26% + 40px)" }}>
                                                                            <Typography fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" >
                                                                                Total: <span style={{ color: sumWeight(formik.values.probation_topic[index].probation_item) > 0 ? sumWeight(formik.values.probation_topic[index].probation_item) === 100 ? "#5DA196" : "#CC6058" : "#BABABA", "font-weight": "500", "font-size": "16px", "line-height": "24px", "padding-left": "70px" }}>{sumWeight(formik.values.probation_topic[index].probation_item)}</span>
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                :
                                                                null
                                                            }
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                                    <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.icon')} <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                    <Box sx={{
                                                        position: "relative",
                                                        marginTop: "16px",
                                                        ".MuiFormControl-root": {
                                                            marginTop: "0"
                                                        }
                                                    }}>
                                                        <TextField
                                                            error={onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.icon, false) === false : false}
                                                            fullWidth
                                                            // helperText={formik.touched.icon && formik.errors.icon}
                                                            margin="normal"
                                                            name="icon"
                                                            onChange={e => changeProbation_topic(e, "probation_topic", "icon", index)}
                                                            type="text"
                                                            value={formik.values.probation_topic[index].icon}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                            placeholder={t('admin.inputForm.placeholder.icon')}
                                                            classes={{ root: classes.input }}
                                                            inputProps={{ readOnly: true }}
                                                        // size="small"
                                                        />
                                                        <Button sx={{ padding: "5.5px 8px !important", textTransform: "capitalize", color: "#404349" }} style={styles.buttonFile} onClick={e => onOpenIcon(index)} >{t('admin.inputForm.browse')}</Button>
                                                    </Box>
                                                    {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.icon, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                </Grid>
                                                <Grid item lg={6} md={6} xs={6} display="flex" sx={{ paddingTop: "0 !important" }}>
                                                    <ClickAwayListener onClickAway={e => handleClose(e, formik.values.probation_topic[index].time)}>
                                                        <Box>
                                                            <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.backgroundColor')}<span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                                                            <Box sx={{
                                                                position: "relative",
                                                                marginTop: "16px",
                                                                ".MuiFormControl-root": {
                                                                    marginTop: "0"
                                                                },
                                                                ".MuiFormHelperText-root": {
                                                                    marginTop: "3px"
                                                                }
                                                            }}>
                                                                <Box py="5px" pl="7px" sx={{ display: "flex", position: "relative", cursor: "pointer", "align-items": "center", width: "130px", height: "41px", border: onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.color, false) === false ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px" }} onClick={e => onOpenColor(formik.values.probation_topic[index].time)}>
                                                                    <Box sx={{ "background-color": formik.values.probation_topic[index].color, height: "28px", width: "85px", "border-radius": "3px" }} mr="15px"></Box>
                                                                    <Dropdown style={{ color: "#404349", fontSize: "16px", fontWeight: "300" }} ></Dropdown>
                                                                </Box>
                                                                <Box sx={{ position: "absolute", "z-index": "9", }}>
                                                                    <Box sx={{ "box-shadow": "0px 4px 10px rgb(0 0 0 / 10%)", "border-radius": "10px", overflow: "hidden", transition: "all .8s", "max-height": openColor[formik.values.probation_topic[index].time] === true ? "999px" : "0px", width: "max-content" }}>
                                                                        <Box sx={{ width: "100%", "max-width": "540px", background: "white", "min-height": "400px", "padding": "30px 30px 44px", }}>
                                                                            <Typography fontSize={24} lineHeight="26.4px" color="#404349" fontWeight="500" pb="20px">Color</Typography>
                                                                            <Divider />
                                                                            <Box pt="20px" pb="25px" sx={{ ".MuiFormControl-root": { "margin-bottom": "0px" }, display: "flex", "align-items": "center", "margin": "0 -25px" }}>
                                                                                <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                                    <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                                    <TextField
                                                                                        error={Boolean(formik.touched.backgroundColor && formik.errors.backgroundColor)}
                                                                                        helperText={formik.touched.backgroundColor && formik.errors.backgroundColor}
                                                                                        margin="normal"
                                                                                        name="backgroundColor"
                                                                                        onChange={e => changeProbation_topic(e, "probation_topic", "color", index)}
                                                                                        type="text"
                                                                                        value={formik.values.probation_topic[index].color}
                                                                                        variant="outlined"
                                                                                        InputLabelProps={{
                                                                                            shrink: true,
                                                                                        }}
                                                                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                                                        placeholder={t('admin.inputForm.placeholder.backgroundColor')}
                                                                                        classes={{ root: classes.input }}
                                                                                    // size="small"
                                                                                    />
                                                                                </Box>
                                                                                <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                                    <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                                    <Box sx={{ width: "100%", height: "41px", background: formik.values.probation_topic[index].color, "border-radius": "4px" }} ></Box>
                                                                                </Box>
                                                                            </Box>
                                                                            <Typography fontSize={16} lineHeight="24px" pb="10px" color="#404349" fontWeight="400">Template Colors</Typography>
                                                                            <Box sx={{ margin: "-10px -10px", display: "flex", "flex-flow": "row wrap" }}>
                                                                                {List.config.length > 0 ?
                                                                                    List.config.map(item => (
                                                                                        <Box onClick={e => setDataItem(item.color, "probation_topic", "color", index)} sx={{ cursor: "pointer", backgroundColor: item.color, width: "40px", height: "40px", "border-radius": "3px", margin: "10px 11.25px" }}></Box>
                                                                                    ))
                                                                                    : null
                                                                                }
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                {onSubmit ? Util.formatData(formik?.values?.probation_topic[index]?.color, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                            </Box>
                                                        </Box>
                                                    </ClickAwayListener>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "40px 0px 20px 25px" }}>
                                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                                    <Divider></Divider>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 0px 25px" }}>
                                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                                    <Typography variant="subtitle1" color="#A3A3A3" fontSize={18} fontWeight={500} lineHeight="24px" display="flex">{t('admin.label.previewCustomFormTemplate')}</Typography>
                                                    {formik.values.probation_topic[index].icon !== "" ?
                                                        <Box sx={{ backgroundColor: formik.values.probation_topic[index].color, width: "80px", height: "80px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
                                                            <Icon sx={{ color: "#ffffff", "font-size": "50px" }}>{formik.values.probation_topic[index].icon}</Icon>
                                                        </Box>
                                                        :
                                                        <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">-</Typography>
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" justifyContent="flex-end" paddingBottom="32px" paddingRight="32px">
                                                <Box display="flex" alignItems="center" height="45px" onClick={e => formik?.values?.probation_topic.length > 1 ? selectDel(probation_topic, "probation_topic", setProbationTopic, index, formik.values.probation_topic[index].time) : null} sx={{ cursor: formik?.values?.probation_topic.length > 1 ? "pointer" : "" }}>
                                                    {formik?.values?.probation_topic.length > 1 ? <TrashRed /> : <TrashRedDis />}
                                                    <Typography pl="15px" fontWeight="500" sx={{ textDecoration: "underline" }} color={formik?.values?.probation_topic.length > 1 ? "#CC6058" : "#BABABA"} fontSize={18} lineHeight="26.91px">Delete Category</Typography>
                                                </Box>
                                            </Box>
                                        </Collapse>
                                    </Paper>
                                </Grid>
                            ))
                                :
                                null
                            }
                            <Grid container mt={3} mb={3} >
                                <Grid item xs display="flex" justifyContent="flex-end" alignItems="center">
                                    <Typography pr="30px" fontSize={18} color="#404349" lineHeight="26.91px" fontWeight="500">
                                        {t('label.totalRatio')}:
                                    </Typography>
                                    <Typography pr="30px" fontSize={18} color={sumRatio(formik.values.probation_topic) > 0 ? sumRatio(formik.values.probation_topic) === 100 ? "#5DA196" : "#CC6058" : "#BABABA"} lineHeight="26.91px" fontWeight="500">
                                        {sumRatio(formik.values.probation_topic)}
                                    </Typography>
                                    <Box mr={2} sx={{ width: "100px" }}>
                                        <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                            {t('label.cancel')}
                                        </Button>
                                    </Box>
                                    <Box sx={{ width: "100px" }}>
                                        <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                            {t('label.save')}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <DialogIcon open={openIcon} close={onCloseIcon} data={dataIcon} icon={onSelectIcon} />
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.customFormTemplateWasEditedSuccessfully')}
                        subTitle=""
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText}
                        twoline={true}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("corporateGoal.label.dialog.discardTitle")} text={t("corporateGoal.label.dialog.discardText")} />
                    <ConfirmDialog open={openDel} doConfirm={() => confirmDel()} setValue={() => confirmDel("no")} title={t('label.confirmationofDeletion')} text={t("label.sureDeleteCategory")} />
                </Container>
            </Box>
            {Util.ScrollToTop()}
        </>
    )
};
export default CompetencyTypeCreate;
